import {useState} from "react";
import axios from "axios";

export const Upload = () => {
	const [file, setFile] = useState(null);

	const onFileChange = (e) => {
		setFile(e.target.files[0]);
	};

	const onUpload = async () => {
		const formData = new FormData();
		formData.append('file', file);

		try {
			const response = await axios.post('./upload.php', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			console.log(response.data);
			alert(response.data);
		} catch (error) {
			console.error("Error uploading file:", error);
		}
	};

	return (
		<div>
			<input type="file" onChange={onFileChange} />
			<button onClick={onUpload}>Upload</button>
		</div>
	);
}